import { CustomerEmployee, PixKeyType } from "~/application/types";
import { DateUtils } from "~/application/utils";
import { DateFormats } from "~/application/utils/date-functions";
import { CustomerEmployeeDTO } from "../dtos";
import { mapProfileDTO } from "./mapProfileDTO";
import { mapBranchDTO } from "./mapBranchDTO";

export function mapCustomerEmployeeDTO(data: CustomerEmployeeDTO): CustomerEmployee {
  return {
    uuid: data.uuid,
    name: data.name,
    lastName: data.last_name,
    phone: data.phone,
    email: data.email,
    pixKey: data.pix_key,
    pixType: data.pix_type as PixKeyType,
    gender: data.gender,
    group: data.group,
    cpf: data.cpf,
    rg: data.rg,
    birthDate: data.birthdate,
    registration: data.registration,
    position: data.position,
    outsourced: data.outsourced,
    passportNumber: data.passport_number,
    passportExpiration: data.passport_expiration
      ? DateUtils.format(data.passport_expiration, DateFormats.SMALL_DATE)
      : "",
    isVip: data.is_vip,
    loyaltyLatam: data.loyalty_latam,
    loyaltyAzul: data.loyalty_azul,
    loyaltyGol: data.loyalty_gol,
    preferredSeat: data.preferred_seat,
    roadLocation: data.road_location,
    typeAirSeat: data.type_air_seat,
    costCenters: data.cost_centers
      ? data.cost_centers.map((costCenter) => ({
          uuid: costCenter.uuid,
          name: costCenter.name,
          belongsToHeadquarters: Boolean(costCenter.belongs_to_headquarters),
          branches: costCenter.branches?.map(mapBranchDTO),
        }))
      : undefined,
    customerId: data.customer_uuid,
    policyId: data.policy_uuid,
    isActive: Boolean(data.active ?? data.is_active ?? data.is_user_active ?? true),
    userId: data.user_uuid,
    isUserActive: data.is_user_active,
    profile: data?.profile ? mapProfileDTO(data.profile) : undefined,
    avatarUrl: data.avatar_url ?? undefined,
    hasHeadquartersAccess: data.has_headquarters_access || false,
    branches: data.branches?.map(mapBranchDTO),
  };
}
